import L from 'leaflet'

const OBJSORT = (a, b) => {
  if (a.value < b.value) {
    return -1
  }
  if (a.value > b.value) {
    return 1
  }
  return 0
}

const ARRAYSORT = (a, b) => {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}

const MARKERICON = properties => {
  return L.divIcon({
    html: `<div class="${properties.selected} ${properties.hidden}"></div>`,
    iconSize: [25, 24],
    iconAnchor: [12, 12], // relativo iconSize
    popupAnchor: [-5, -30],
    shadowSize: [0, 0],
    className: `marker ${properties.type} ${properties.selected} ${properties.hidden}  status-${properties.status.toLowerCase()}`
  })
}

export {
  MARKERICON,
  OBJSORT,
  ARRAYSORT
}



// WEBPACK FOOTER //
// ./src/utils/index.js